/**
 * Returns an array of type number for the specified range.
 * Both from and to are inclusive
 *
 * Example:
 *  range(1, 5) => [1, 2, 3, 4, 5]
 *
 * @param from - range start (inclusive)
 * @param to   - range end (inclusive)
 */
export function range(from: number, to: number): number[] {
  return [...Array(to + 1).keys()].slice(from);
}
